import React, { useState, useMemo } from "react";
import Select from "react-select";

const PaginatedSelect = ({ options, handleChange, value, placeholder }) => {
  const PAGE_SIZE = 50;
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleOptionsCount, setVisibleOptionsCount] = useState(PAGE_SIZE);

  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options;
    const lowerSearch = searchTerm.toLowerCase();
    return options.filter((option) => option.label.toLowerCase().includes(lowerSearch));
  }, [searchTerm, options]);

  const visibleOptions = useMemo(() => {
    return filteredOptions.slice(0, visibleOptionsCount);
  }, [filteredOptions, visibleOptionsCount]);

  const handleMenuScrollToBottom = () => {
    if (visibleOptionsCount < filteredOptions.length) {
      setVisibleOptionsCount((prev) => Math.min(prev + PAGE_SIZE, filteredOptions.length));
    }
  };

  const handleInputChange = (inputValue) => {
    setSearchTerm(inputValue);
    setVisibleOptionsCount(PAGE_SIZE);
  };

  return (
    <Select
      options={visibleOptions}
      onInputChange={handleInputChange}
      onMenuScrollToBottom={handleMenuScrollToBottom}
      onChange={handleChange}
      value={options.find((opt) => opt.value === value) || null}
      isSearchable
      className="w-full"
      placeholder={placeholder}
    />
  );
};

export default PaginatedSelect;
